export enum ExportTypeEnum {
  Optitax = 'OPTITAX',
  XLS = 'XLS',
  XLSX = 'XLSX',
  CSV = 'CSV',
  PDF = 'PDF',
}
